/**
 * Build system types - shared between client and server
 */
export { identityQuat, invertQuat, multiplyQuats, applyQuatToVec3, xRotationQuat, yRotationQuat, } from '../util/math.js';
// ============== Enums ==============
/**
 * Build mode determines how the shape affects existing voxels.
 */
export var BuildMode;
(function (BuildMode) {
    /** Add material - takes max of existing and new weight */
    BuildMode["ADD"] = "add";
    /** Subtract material - takes min of existing and new weight */
    BuildMode["SUBTRACT"] = "subtract";
    /** Paint - changes material only where weight > 0 */
    BuildMode["PAINT"] = "paint";
    /** Fill - only fills where existing weight <= 0 */
    BuildMode["FILL"] = "fill";
    /**
     * Punch - a material-filtered subtract. Carves like SUBTRACT but only removes voxels whose
     * existing material equals `config.material` (the target material to match). Used by the
     * left-click "punch": the match material is the voxel the crosshair hit, so punching grass digs
     * a blob of grass without touching adjacent stone/brick.
     */
    BuildMode["PUNCH"] = "punch";
})(BuildMode || (BuildMode = {}));
/**
 * Available build shapes.
 */
export var BuildShape;
(function (BuildShape) {
    BuildShape["CUBE"] = "cube";
    BuildShape["SPHERE"] = "sphere";
    BuildShape["CYLINDER"] = "cylinder";
    BuildShape["PRISM"] = "prism";
    /** Capped cone about Y: size.x = base radius, size.y = half-height, size.z = TOP radius (following
     *  the cylinder's precedent of per-shape size semantics — cylinder already ignores size.z). */
    BuildShape["CONE"] = "cone";
})(BuildShape || (BuildShape = {}));
/**
 * Snap shape determines which corners/edges of a build shape generate snap points.
 */
export var BuildPresetSnapShape;
(function (BuildPresetSnapShape) {
    /** No snap points */
    BuildPresetSnapShape["NONE"] = "none";
    /** 8 corners of a box */
    BuildPresetSnapShape["CUBE"] = "cube";
    /** 4 corners of a rectangular plane (XY) */
    BuildPresetSnapShape["PLANE"] = "plane";
    /** 3 corners of a triangular prism face (XY, z=0) */
    BuildPresetSnapShape["PRISM"] = "prism";
    /** 2 endpoints along Y axis */
    BuildPresetSnapShape["LINE"] = "line";
    /** Single point at center */
    BuildPresetSnapShape["POINT"] = "point";
    /** 10 points around cylinder (cardinal + top/bottom center) */
    BuildPresetSnapShape["CYLINDER"] = "cylinder";
})(BuildPresetSnapShape || (BuildPresetSnapShape = {}));
/**
 * The representative config of a parts list — `parts[0].config`. Used where a single
 * config is needed (marker colour, snap size, thumbnail fallback, config-tab editing).
 */
export function representativeConfig(parts) {
    return parts[0].config;
}
// ============== Utility Functions ==============
/**
 * Create a default build config.
 */
export function createDefaultBuildConfig() {
    return {
        shape: BuildShape.CUBE,
        mode: BuildMode.ADD,
        size: { x: 2, y: 2, z: 2 },
        material: 1,
    };
}
// Re-export clamp from math utilities for backwards compatibility
export { clamp } from '../util/math.js';
//# sourceMappingURL=buildTypes.js.map